import { useRoomContext } from "@livekit/components-react";

export const useLivekitLocalParticipant = () => {
  const room = useRoomContext();
  return room.localParticipant;
};
